import { render, staticRenderFns } from "./OrderTypeCardBig.vue?vue&type=template&id=8f103f94"
import script from "./OrderTypeCardBig.vue?vue&type=script&lang=js"
export * from "./OrderTypeCardBig.vue?vue&type=script&lang=js"
import style0 from "./OrderTypeCardBig.vue?vue&type=style&index=0&id=8f103f94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports